import React, { Fragment } from 'react'
import { Typography, Grid } from '@material-ui/core';
import DayCard from './DayCard';

const today = new Date().toISOString().substr(0, 10);

const Display = (props) => {

  // for grouping i need to group them... like map by date...

  const todaysSchedule = props.days.filter(day => day.date === today);

  const todaysCards = 
    <Grid container spacing={1}>
    {todaysSchedule && todaysSchedule.map((day) => {
      return (
        <DayCard key={day.id} day={day} {...props} />
      )
    })}
  </Grid>

  return (
    <div>
      <Typography>All cards are being displayed</Typography>
      <Grid container spacing={1}>
        {props.days && props.days.map((day) => {
          return (
            <DayCard key={day.id} day={day} {...props} />
          )
        })}
      </Grid>
      {
        todaysSchedule && 
        <Fragment>
          <Typography>Todays schedule: </Typography>
          {todaysCards}
        </Fragment>
      }
    </div>
  )
}

export default Display
